import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'

import Item from './Item'

class ScriptLogForm extends React.PureComponent {
  render () {
    const {sceneId, slateId, takeId} = this.props
    const {template, script, actions} = this.props
    const {
      updateScene,
      saveScene,
      deleteScene,
      updateSlate,
      saveSlate,
      deleteSlate,
      updateTake,
      saveTake,
      deleteTake
    } = actions

    return <div>
      {sceneId && script.scenes.byId[sceneId] && <Item
        template={template}
        type="scene"
        entry={script.scenes.byId[sceneId]}
        actions={{
          update: (fieldName, fieldValue) => updateScene(sceneId, fieldName, fieldValue),
          save: () => {
            if (!script.scenes.saveLoading && script.scenes.unsavedChanges)
              saveScene(sceneId)
          },
          delete: () => deleteScene(sceneId)
        }}
        saveLoading={script.scenes.saveLoading}
        deleteLoading={script.scenes.deleteLoading}
      />}

      {slateId && script.slates.byId[slateId] && <Item
        template={template}
        type="slate"
        entry={script.slates.byId[slateId]}
        actions={{
          update: (fieldName, fieldValue) => updateSlate(slateId, fieldName, fieldValue),
          save: () => {
            if (!script.slates.saveLoading && script.slates.unsavedChanges)
              saveSlate(slateId)
          },
          delete: () => deleteSlate(slateId, sceneId)
        }}
        saveLoading={script.slates.saveLoading}
        deleteLoading={script.slates.deleteLoading}
      />}

      {takeId && script.takes.byId[takeId] && <Item
        template={template}
        type="take"
        entry={script.takes.byId[takeId]}
        actions={{
          update: (fieldName, fieldValue) => updateTake(takeId, fieldName, fieldValue),
          save: () => {
            if (!script.takes.saveLoading && script.takes.unsavedChanges)
              saveTake(takeId)
          },
          delete: () => deleteTake(takeId, slateId)
        }}
        saveLoading={script.takes.saveLoading}
        deleteLoading={script.takes.deleteLoading}
      />}

      <div
        style={{
          position: 'fixed',
          right: 50,
          bottom: 50
        }}>
        <Button
          onClick={() => {
            window.location.href = '#/script-log/setup'
          }}
          variant="fab"
          className="jr-fab-btn bg-primary text-white"
        >
          <i className="zmdi zmdi-edit zmdi-hc-fw"/>
        </Button>

      </div>
    </div>
  }
}

ScriptLogForm.propTypes = {
  sceneId: PropTypes.string,
  slateId: PropTypes.string,
  takeId: PropTypes.string,
  template: PropTypes.object.isRequired,
  script: PropTypes.object.isRequired,
  actions: PropTypes.shape({
    updateScene: PropTypes.func.isRequired,
    saveScene: PropTypes.func.isRequired,
    deleteScene: PropTypes.func.isRequired,
    updateSlate: PropTypes.func.isRequired,
    saveSlate: PropTypes.func.isRequired,
    deleteSlate: PropTypes.func.isRequired,
    updateTake: PropTypes.func.isRequired,
    saveTake: PropTypes.func.isRequired,
    deleteTake: PropTypes.func.isRequired
  })
}

export default ScriptLogForm


// WEBPACK FOOTER //
// ./components/ScriptLogForm/index.js